<template>
  <div class="bg-surface rounded-xl p-5 max-w-[58rem] mx-auto mt-6 space-y-7">
    <img
      :src="props.scormCourse.previewImageUrl"
      :alt="t('content.scorm-course-preview-alt')"
      class="w-full object-cover rounded-lg aspect-16/9"
    />

    <div
      v-if="props.scormCourse.description"
      class="prose max-w-full"
      v-html="props.scormCourse.description"
    />

    <div class="text-center pb-3">
      <Btn
        :size="BtnSize.LG"
        :variant="BtnVariant.FILLED"
        :color="BtnColor.PRIMARY"
        @click="onLaunchCourse()"
      >
        {{ t('content.launch-course') }}
      </Btn>
      <Modal
        v-if="courseUrl"
        open
        closable
        :size="ModalSize.FULL"
        :shape="ModalShape.SQUARE"
        full-height
        @close="courseUrl = null"
      >
        <template #content>
          <iframe
            :src="courseUrl"
            allow="autoplay; fullscreen"
            class="w-full h-full"
          />
        </template>
      </Modal>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Btn, BtnColor, BtnSize, BtnVariant } from '~/components/btn';
import { apiInviteToScorm, ContentDto } from '~/api/contents';
import { Modal, ModalShape, ModalSize } from '~/components/modals/modal';

type Props = {
  content: ContentDto;
  scormCourse: NonNullable<ContentDto['scormCourse']>;
};
const props = defineProps<Props>();

const { t } = useI18n();

const courseUrl = ref<null | string>(null);

const onLaunchCourse = async () => {
  await useLoader({
    async action() {
      const res = await apiInviteToScorm(props.content.id);

      courseUrl.value = res.launchUrl;
    },
  });
};
</script>
